import { render } from "./CustomFieldSetup.vue?vue&type=template&id=5236ce64&scoped=true"
import script from "./CustomFieldSetup.vue?vue&type=script&lang=js"
export * from "./CustomFieldSetup.vue?vue&type=script&lang=js"

import "./CustomFieldSetup.vue?vue&type=style&index=0&id=5236ce64&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5236ce64"]])

export default __exports__